import { streamTipTapNodes } from 'helpers/stream';
import { useState } from 'react';

interface UseEmailPreviewStreamingOptions {
  streaming?: boolean;
  token?: string;
  channelName?: string;
}

export const useEmailPreviewStreaming = ({
  streaming = true,
  token,
  channelName,
}: UseEmailPreviewStreamingOptions) => {
  const [isInitializingStream, setIsInitializingStream] = useState(false);

  const onStart = () => {
    setIsInitializingStream(true);
  };

  const onInitialization = async (editor: any) => {
    if (!streaming || !token || !channelName) {
      return;
    }

    await streamTipTapNodes({
      editor,
      identifierType: 'templateSectionId',
      identifierValues: ['-1'],
      token,
      channelName,
      onStart,
    });
  };

  return {
    isInitializingStream,
    onInitialization,
  };
};
